/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Upload_Gate_Hint_BranchInputs */

const en_case_upload_gate_hint_branch = /** @type {(inputs: Case_Upload_Gate_Hint_BranchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a branch to enable uploads.`)
};

const pt_br2_case_upload_gate_hint_branch = /** @type {(inputs: Case_Upload_Gate_Hint_BranchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma filial para habilitar o envio de arquivos.`)
};

/**
* | output |
* | --- |
* | "Select a branch to enable uploads." |
*
* @param {Case_Upload_Gate_Hint_BranchInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_upload_gate_hint_branch = /** @type {((inputs?: Case_Upload_Gate_Hint_BranchInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Upload_Gate_Hint_BranchInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_upload_gate_hint_branch(inputs)
	return pt_br2_case_upload_gate_hint_branch(inputs)
});